import './App.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Landing from './pages/Landing';
import Assessment from './pages/Assessment';
import AuthCallback from './pages/AuthCallback';
import Result from './pages/Result';
import Report from './pages/Report';
import Prescription from './pages/Prescription';
import Admin from './pages/Admin';
import ExpertsMarketplace from './pages/ExpertsMarketplace';
import BecomePartner from './pages/BecomePartner';
import WellnessSpaces from './pages/WellnessSpaces';
import ImproveYourScore from './pages/ImproveYourScore';
import Collaborate from './pages/Collaborate';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import SiteHeader from './components/SiteHeader';
import { Toaster } from './components/ui/sonner';
import { LanguageProvider } from './i18n/LanguageContext';

function AppRouter() {
  const location = useLocation();

  // Check URL fragment for session_id synchronously during render
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  // Hide the floating WhatsApp button on the admin dashboard
  const isAdmin = location.pathname.startsWith('/admin');

  return (
    <>
      <SiteHeader />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/assessment" element={<Assessment />} />
        <Route path="/result/:assessmentId" element={<Result />} />
        <Route path="/report/:slug" element={<Report />} />
        <Route path="/prescription/:assessmentId" element={<Prescription />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/experts" element={<ExpertsMarketplace />} />
        <Route path="/spaces" element={<WellnessSpaces />} />
        <Route path="/improve" element={<ImproveYourScore />} />
        <Route path="/collaborate" element={<Collaborate />} />
        <Route path="/partners" element={<BecomePartner />} />
        <Route path="/partners/list-business" element={<BecomePartner />} />
        <Route path="/partners/corporate" element={<BecomePartner />} />
        <Route path="/partners/referral" element={<BecomePartner />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      {/* Floating WhatsApp widget temporarily disabled — re-enable by adding:
          {!isAdmin && <FloatingWhatsApp />} */}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-center" theme="dark" />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
